











































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import JobModel from '@views/a-model/job-model';
import DefaultModel from '@views/a-model/default-model';
import EnumNewsType from '../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import VacancyTranslation from '../../dataSource/api/RunPay/Admin/IServices/Models/UserMobile/VacancyTranslation';

@Component({
  name: 'job_openings',
  components: {},
})
export default class Job_openingsComponent extends Vue {
  innerItems: JobModel[] = [];

  langArr = ['en', 'ar', 'fr', 'ru'];
  defaultLang = 'fr';
  // langArr = [ 'ro', 'ru'];
  // defaultLang = 'ro';

  pageSize = 13;
  currentPage = 1;
  totalItems = 0;

  modalWindowTitle = '';
  modalWindowShow = false;
  currentOperation = 'add';
  currentEditItemId = 0;

  editImage = false; // индиктор изменения картинки в режиме Edit

  addingJob: JobModel = new JobModel();

  newsCategories = Array<ListViewItem<DefaultModel>>();

  created() {
    document.title = this.$locale.getTranslate('BaseMenu_job_openings');
    const appsettings = require('../../../appsettings.json');
    const ProjectOptions = appsettings.ProjectOptions;
    this.langArr = ProjectOptions.langArr;
    this.defaultLang = ProjectOptions.defaultLang;
    // this.getNewsCategory()

    this.getItems({ Take: this.pageSize, Skip: 0 });
  }

  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }

  getItems({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.VacancyService.GetListEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items.map((item) => ({
        id: item.Id,
        name: this.defaultName(item.Translations),
        shortDescription: this.defaultShortDescription(item.Translations),
        // translations: item.Translations,
        translations: this.getTranslations(item.Translations, item.Id), // description: item.Description.toString(),
      }));
    });
    this.$api.VacancyService.GetList({
      Skip: Skip,
      Take: this.pageSize,
    });
  }

  getTranslations(value: VacancyTranslation[], id: number): VacancyTranslation[] {
    this.langArr.forEach((i) => {
      const finde = value.filter((item) => item.LangCode == i);

      if (finde.length == 0) {
        value.push({ LangCode: i, ShortDescription: '', Description: '' });
      }
    });
    value = value.filter((i) => {
      const finde = this.langArr.filter((item) => item == i.LangCode);
      return finde.length != 0;
    });
    return value;
  }

  defaultName(val: Array<VacancyTranslation>): string {
    const currentLang = this.$locale.currentLang;
    // if (val.length==1) return (val[0].Name||"").toString();
    return ((val.find((el) => el.LangCode == currentLang) || val[0]).Name || '').toString();
  }

  defaultShortDescription(val: Array<VacancyTranslation>): string {
    const currentLang = this.$locale.currentLang;
    // if (val.length==1) return (val[0].Name||"").toString();
    return ((val.find((el) => el.LangCode == currentLang) || val[0]).ShortDescription || '').toString();
  }

  onSearch() {
    this.getItems({ Take: this.pageSize, Skip: 0 });
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.currentPage = request.Page;
    this.getItems({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }

  onNewsAdd() {
    this.modalWindowTitle = this.$locale.getTranslate('add_job_openings');
    this.currentOperation = 'add';
    this.addingJob = new JobModel();
    this.addingJob.translations = new Array<VacancyTranslation>();
    this.langArr.forEach((i) => {
      this.addingJob.translations.push({ LangCode: i, ShortDescription: '', Description: '' });
    });
    this.modalWindowShow = true;
  }

  onNewsEdit(id: number) {
    this.addingJob = new JobModel();
    this.modalWindowTitle = this.$locale.getTranslate('edit_job_openings');
    this.currentOperation = 'edit';
    this.currentEditItemId = id;

    var itemJob = this.innerItems.filter((item) => item.id == id)[0];

    if (itemJob.translations.length == 0) {
      itemJob.translations.push({ LangCode: this.$locale.getLangCodeById(0), Name: '', ShortDescription: '', Description: '' });
      itemJob.translations.push({ LangCode: this.$locale.getLangCodeById(4), Name: '', ShortDescription: '', Description: '' });
    }
    if (itemJob.translations.length == 1) {
      itemJob.translations.push({ LangCode: this.$locale.getLangCodeById(4), Name: '', ShortDescription: '', Description: '' });
    }
    this.addingJob = itemJob;
    this.modalWindowShow = true;
  }

  closeModalWindow() {
    this.modalWindowShow = false;
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case 'id':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case 'name':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }

      default:
        break;
    }
  }

  async onDelete(newsId: string) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      if (res) {
        this.$api.VacancyService.DeleteEvent.once((response) => {
          if (!response.IsSuccess) {
            return;
          }
          this.getItems({ Take: this.pageSize, Skip: 0 });
        });
        this.$api.VacancyService.Delete(parseInt(newsId));
      }
      if (res == false) {
      }
    });
  }

  onOperation() {
    if (!this.isValid()) {
      return;
    }
    this.$api.VacancyService.SaveEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.closeModalWindow();
      this.innerItems = [];
      this.getItems({ Take: this.pageSize, Skip: 0 });
    });
    this.$api.VacancyService.Save({
      Id: this.addingJob.id,
      Translations: this.addingJob.translations,
    });
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-job_openings.vue